import React from "react";
import type { Indicator } from "../configs/constants";

type Categories = Array<{
  value: string;
  color: string;
}>;

function groupMatches(matches: Array<string>): Categories {
  const categories: Categories = [];
  for (let i = 0; i < matches.length; i += 2) {
    const value = matches[i];
    const color = matches[i + 1];
    categories.push({ value, color });
  }
  return categories;
}

export function Legend({ indicator }: { indicator: Indicator }) {
  const { expression } = indicator;
  const expr = expression["fill-color"] as mapboxgl.Expression;

  if (expr[0] === "case") {
    const color = expr[2];
    return (
      <div className="legend">
        <div className="legend-category">
          <div className="swatch" style={{ backgroundColor: color }}></div>
          <div className="swatch-label">Health equity zone</div>
        </div>
      </div>
    );
  } else if (expr[0] === "match") {
    const matches = expr.slice(2, -1);
    const categories = groupMatches(matches);

    return (
      <div className="legend">
        {categories.map(({ value, color }, i) => (
          <div className="legend-category" key={i}>
            <div className="swatch" style={{ backgroundColor: color }}></div>
            <div className="swatch-label">
              {indicator.format(value, "legend")}
            </div>
          </div>
        ))}
      </div>
    );
  } else if (expr[0] === "interpolate") {
    const matches = expr.slice(3);
    const [min, max] = groupMatches(matches);

    return (
      <div className="legend">
        <div
          className="legend-bar"
          style={{
            backgroundImage: `linear-gradient(to right, ${min.color}, ${max.color})`,
          }}
        >
          <div className="min">
            {(["temp", "eveairavg", "aftairavg"].includes(indicator.field) &&
              "Low") ||
              indicator.format(min.value)}
          </div>
          <div className="max">
            {(["temp", "eveairavg", "aftairavg"].includes(indicator.field) &&
              "High") ||
              indicator.format(max.value)}
          </div>
        </div>
      </div>
    );
  }
}
